module.exports = __webpack_public_path__ + "img/newfive1.3d66acaa.jpg";